module.exports = __webpack_public_path__ + "img/choose-up-Up Social Cluj-disabled.47ac394a.png";